import { PlusOutlined } from '@ant-design/icons';
import { Product, WaterbodyDetail } from '@omniafishing/core';
import classNames from 'classnames';
import pluralize from 'pluralize';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useQueryString } from '../../../../hooks/use_query_string';
import { useResponsive } from '../../../../hooks/use_responsive';
import { WebAnalytics } from '../../../../lib/web_analytics';
import { hasAccessToken } from '../../../../redux/auth';
import { FishingReportModalActions } from '../../../../redux/fishing_report_modal';
import { OmniaButton } from '../../../omnia_button/omnia_button';
import { WaterbodyFollowButtonLoggedIn } from '../../../waterbody_follow_button_logged_in/waterbody_follow_button_logged_in';
import { WaterbodyFollowButtonLoggedOut } from '../../../waterbody_follow_button_logged_out/waterbody_follow_button_logged_out';
import { WaterbodyDetailQueryParams } from '../../waterbody_detail';
import styles from './waterbody_detail_header_buttons.less';
interface WaterbodyDetailHeaderButtonsProps {
  isSticky: boolean;
  scrollToFishingReport: () => void;
  waterbody: WaterbodyDetail;
  productToShowInFollowModal: Product;
}

export const WaterbodyDetailHeaderButtons = (props: WaterbodyDetailHeaderButtonsProps) => {
  const { isSticky, scrollToFishingReport, waterbody, productToShowInFollowModal } = props;
  const { favorites_count, fishing_reports_count } = waterbody;

  const isLoggedIn = useSelector(hasAccessToken);
  const { isDesktop, isMobile } = useResponsive();
  const dispatch = useDispatch();

  const { getCurrentQuery } = useQueryString();
  const currentQuery = getCurrentQuery<WaterbodyDetailQueryParams>();

  const webAnalyticsLakeClickArgs = {
    season: currentQuery.season_group,
    species: currentQuery.species,
    technique: currentQuery.technique,
    waterbody_slug: waterbody.url_slug,
  };

  const fileFishingReport = () => {
    dispatch(FishingReportModalActions.FISHING_REPORT_MODAL_OPEN(waterbody));
  };

  const headerIsNotSticky = !isSticky;
  const hasFishingReports = fishing_reports_count > 0;

  const handleFollowClick = useCallback(() => {
    WebAnalytics.lakePageClick('[overview].(subscribe)', webAnalyticsLakeClickArgs);
  }, []);

  return (
    <div
      className={classNames(styles.headerButtonSection, {
        [styles.headerButtonSection__sticky]: isSticky,
      })}
    >
      <div className={styles.headerColFishingReport}>
        <div className={styles.fileReportButton}>
          <OmniaButton
            size={isMobile ? 'md' : 'lg'}
            kind="tertiary"
            fontSize={14}
            shape={isMobile ? 'square' : 'rectangle'}
            onPress={() => {
              fileFishingReport();
              WebAnalytics.lakePageClick('[overview].(fishing_reports)', webAnalyticsLakeClickArgs);
            }}
          >
            <PlusOutlined className={styles.plusIcon} />
            {isDesktop && 'File a Fishing Report'}
          </OmniaButton>
        </div>
        {hasFishingReports && headerIsNotSticky && (
          <span className={styles.fishingReportCount} onClick={scrollToFishingReport}>
            {fishing_reports_count} Fishing Report{fishing_reports_count > 1 && 's'}
          </span>
        )}
      </div>
      <div className={styles.headerColFollow}>
        {isLoggedIn ? (
          <WaterbodyFollowButtonLoggedIn
            microMobileButton
            waterbody={waterbody}
            onClick={handleFollowClick}
            noPopup
            buttonSize={isMobile ? 'md' : 'lg'}
          />
        ) : (
          <WaterbodyFollowButtonLoggedOut
            microMobileButton
            waterbody={waterbody}
            onClick={handleFollowClick}
            productToShow={productToShowInFollowModal}
            className={styles.followButton__loggedOut}
            buttonSize={isMobile ? 'md' : 'lg'}
          />
        )}
        {headerIsNotSticky && (
          <span className={styles.followCount}>
            {favorites_count} {pluralize('Follower', favorites_count)}
          </span>
        )}
      </div>
    </div>
  );
};
